import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { ITheme } from "../../../utils/theme";

interface IConfirmationProps {}

export const Confirmation: React.FC<IConfirmationProps> = () => (
  <Box sx={{ p: { xs: 0, md: 2 } }}>
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ p: 0, mt: 2 }}>
        <Box sx={{ maxWidth: 400, mx: "auto" }} data-automation="confirmation-txt">
          <Typography
            sx={{
              color: (theme: ITheme) => theme.palette.corporateBlue,
              mb: 1,
            }}
          >
            An email confirmation of your changes has been sent.
          </Typography>
          <Typography
            sx={{ color: (theme: ITheme) => theme.palette.corporateBlue }}
          >
            You can close this window.
          </Typography>
        </Box>
      </Grid>
    </Grid>
  </Box>
);
